var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.activeStateMod,{tag:"component",staticClass:"w-full",attrs:{"editState":_vm.editState,"states":_vm.states,"statesWithKey":_vm.statesWithKey}})}
var staticRenderFns = []

export { render, staticRenderFns }